export default "__VITE_ASSET__DPBOaJcc__"